import "./Compliance4.module.css";
import Header from "@/reusable_sections/Header";
import Compliance from "./sections/Compliance";
import Compliancedocuments from "./sections/Compliancedocuments";
import Footer from "@/reusable_sections/Footer";
export default function Compliance4Page() {
  return <div>
      <Header />
      <Compliance />
      <Compliancedocuments />
      <Footer />
    </div>;
}